import React, { useEffect } from 'react';
import { Button, MenuItem } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { toJS } from 'mobx';
import { useRootStore } from '../../../stores/BridgeProvider';
import { WideBox } from '../../styles/styles';
import VoucherForm from '../VoucherForm';
import { VoucherStatusEnums } from '../../common/Enums';
import { safeEval, filterPreference } from '../../util/UtilFunctions';

const EditVoucher = ({ voucher, setEditMode, fetchVoucher }) => {
  const { authStore, dataStore, orgStore } = useRootStore();
  const history = useHistory();
  const type = safeEval(() => orgStore.settings.VoucherTypeDefault);
  const { Pending } = voucher;
  const showDelete = !Pending && voucher.VoucherId && voucher.StatusId < 3;
  const { accountInfo } = authStore;

  const deleteVoucher = async () => {
    try {
      await authStore.request.delete(
        `${process.env.REACT_APP_API}/api/voucher/`,
        {
          data: { VoucherId: voucher.VoucherId },
        },
      );
      dataStore.retrieveAllVouchers();
      history.push('/vouchers');
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <WideBox showoverflow={1} style={{ maxWidth: '500px' }}>
      <VoucherForm
        type={type}
        onSubmit={async values => {
          try {
            const nPref = filterPreference(
              accountInfo.NotificationPref,
              'Transaction Status',
            );
            const {
              VoucherId,
              VoucherTypeId,
              VoucherNumber,
              Description,
              VoucherDate,
              Amount,
              ContactId,
              DueDate,
              StatusId,
              AccountId,
            } = values;
            await authStore.request.post(
              `${process.env.REACT_APP_API}/api/voucher/`,
              {
                VoucherId,
                VoucherTypeId,
                VoucherNumber,
                Description,
                VoucherDate,
                Amount,
                ContactId,
                DueDate,
                StatusId,
                AccountId,
                IsHidden: 0,
                NotificationPref: nPref,
                Email: {
                  address: accountInfo.Email,
                  name: accountInfo.Name.split(' ')[0],
                  status: VoucherStatusEnums[StatusId],
                },
              },
            );
            fetchVoucher();
            dataStore.retrieveAllVouchers();
            setEditMode(false);
          } catch (e) {
            console.error(e);
          }
        }}
        menuItems={
          showDelete
            ? [
                <MenuItem key={1} onClick={deleteVoucher}>
                  Delete Voucher
                </MenuItem>,
              ]
            : null
        }
        buttons={[
          <Button
            key={1}
            variant="outlined"
            color="secondary"
            onClick={() => setEditMode(false)}
            size="large"
          >
            Cancel
          </Button>,
        ]}
        voucher={voucher}
      />
    </WideBox>
  );
};

export default EditVoucher;
